/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CreateLiveAssistDemoData } from './CreateLiveAssistDemoData.js';
import {
    CreateLiveAssistDemoDataFromJSON,
    CreateLiveAssistDemoDataFromJSONTyped,
    CreateLiveAssistDemoDataToJSON,
} from './CreateLiveAssistDemoData.js';

/**
 * 
 * @export
 * @interface CreateLiveAssistDemoResponse
 */
export interface CreateLiveAssistDemoResponse {
    /**
     * 
     * @type {CreateLiveAssistDemoData}
     * @memberof CreateLiveAssistDemoResponse
     */
    data?: CreateLiveAssistDemoData;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveAssistDemoResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveAssistDemoResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveAssistDemoResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateLiveAssistDemoResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateLiveAssistDemoResponse interface.
 */
export function instanceOfCreateLiveAssistDemoResponse(value: object): boolean {
    return true;
}

export function CreateLiveAssistDemoResponseFromJSON(json: any): CreateLiveAssistDemoResponse {
    return CreateLiveAssistDemoResponseFromJSONTyped(json, false);
}

export function CreateLiveAssistDemoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLiveAssistDemoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateLiveAssistDemoDataFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateLiveAssistDemoResponseToJSON(value?: CreateLiveAssistDemoResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': CreateLiveAssistDemoDataToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

